import { toast } from '@/components/toasts/toast.helpers'

import { fetchingAPI, apiService } from '../../api'
import { setCourses, setLoading, setActiveCourseURL } from './baltoAcademy.redux'

export const getCourses = (clientIdentifier) => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const url = clientIdentifier
      ? `${apiService.core}/api/balto_academy/courses?clientId=${clientIdentifier}`
      : `${apiService.core}/api/balto_academy/courses`
    const response = await fetchingAPI(url, 'GET', dispatch)

    dispatch(setCourses(response))
    return response
  } catch (err) {
    toast.error('Failed to fetch courses', { cause: err })
    return []
  } finally {
    dispatch(setLoading(false))
  }
}

export const getCoassembleClients = () => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const url = `${apiService.core}/api/balto_academy/clients`
    const response = await fetchingAPI(url, 'GET', dispatch)

    return Array.isArray(response) ? response : []
  } catch (err) {
    toast.error('Failed to fetch organizations', { cause: err })
    return []
  } finally {
    dispatch(setLoading(false))
  }
}

export const getCourseTrackings = (courseId, clientId) => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const url = `${apiService.core}/api/balto_academy/trackings?id=${courseId}&clientId=${clientId}`
    const response = await fetchingAPI(url, 'GET', dispatch)

    return Array.isArray(response) ? response : []
  } catch (err) {
    toast.error('Failed to fetch course trackings', { cause: err })
    return []
  } finally {
    dispatch(setLoading(false))
  }
}

export const getUserTrackings = (identifier) => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const url = `${apiService.core}/api/balto_academy/user/trackings?identifier=${encodeURIComponent(
      identifier
    )}`
    const response = await fetchingAPI(url, 'GET', dispatch)

    return {
      totals: {
        viewed: response?.totals?.viewed ?? 0,
        completed: response?.totals?.completed ?? 0,
        averageProgress: response?.totals?.averageProgress ?? 0,
      },
      trackings: Array.isArray(response?.trackings) ? response.trackings : [],
    }
  } catch (err) {
    toast.error('Failed to fetch user trackings', { cause: err })
    return { totals: { viewed: 0, completed: 0, averageProgress: 0 }, trackings: [] }
  } finally {
    dispatch(setLoading(false))
  }
}

export const getCourseURL = (courseId, username, organizationId) => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const url = `${apiService.core}/api/balto_academy/course`
    const response = await fetchingAPI(
      url,
      'POST',
      dispatch,
      JSON.stringify({
        action: 'view',
        id: courseId,
        identifier: username,
        clientIdentifier: organizationId,
      })
    )

    dispatch(setActiveCourseURL(response.url))
  } catch (err) {
    toast.error('Failed to fetch url for course', { cause: err })
  } finally {
    dispatch(setLoading(false))
  }
}
